import { z } from "zod";
import { DeliveryFormSchema } from "../home/cotationDeliveryForm.form";
import { GetOneExpeditionResponseDto } from "../../api/api-types";
import { nanoid } from "nanoid";
import { WineColorEnum } from "@/constants/enums/wineColor.enum";
import { parseEnum } from "@/lib/enums.util";
import { i18nMessage } from "@/lib/i18nMessage";

const UpdateTrackingSchemaUnrefined = z.object({
  trackingCode: z.string().optional(),
  trackingUrl: z.string().optional(),
  manualTracking: z.boolean(),
});

export const CotationUpdateBoFormSchema = UpdateTrackingSchemaUnrefined.and(
  DeliveryFormSchema,
).refine((data) => (!data.manualTracking ? !!data.trackingCode : true), {
  path: ["trackingCode"],
  message: i18nMessage("shared:forms.quotationUpdateBo.trackingCodeRequired"),
});

export type CotationUpdateBoFormData = z.infer<typeof CotationUpdateBoFormSchema>;

type Props = {
  expedition: GetOneExpeditionResponseDto;
  prefPickUpLocation: string | undefined;
  defaultBillingEntity: string | undefined;
};

export const CotationUpdateBoDefaultValues = ({
  expedition,
  prefPickUpLocation,
  defaultBillingEntity,
}: Props) => {
  return {
    company: expedition?.deliveryInfo?.company || undefined,
    lastName: expedition?.deliveryInfo?.lastName || undefined,
    firstName: expedition?.deliveryInfo?.firstName || undefined,
    email: expedition?.deliveryInfo?.email || undefined,
    phone: expedition?.deliveryInfo?.phone || undefined,
    street: expedition?.deliveryInfo?.street || undefined,
    postalCode: expedition?.deliveryInfo?.postalCode || undefined,
    city: expedition?.deliveryInfo?.city || undefined,
    countryCode: expedition?.deliveryInfo?.country || undefined,
    stateOrProvinceCode: expedition?.deliveryInfo?.state || undefined,
    customId: expedition?.quotation?.customId || undefined,
    deliveryContent:
      (expedition?.quotation?.deliveryContent &&
        expedition?.quotation?.deliveryContent.length > 0 &&
        expedition?.quotation?.deliveryContent.map((product) => ({
          wineName: product.wineName,
          year: product.year,
          alcoholPercent: product.alcoholPercent,
          volume: product.volume,
          color: parseEnum(WineColorEnum, product.color) ?? WineColorEnum.ROUGE,
          quantity: product.numberOfBottles,
          price: product.unitPrice,
          id: nanoid(),
          isEditing: false,
        }))) ||
      expedition?.quotation?.quotationProducts?.map((product) => ({
        wineName: undefined,
        year: undefined,
        alcoholPercent: undefined,
        volume: product.volume,
        color: undefined,
        quantity: product.bottleQuantity,
        price: undefined,
      })) ||
      [],
    woodBoxes:
      expedition?.quotation?.quotationWoodBox?.map((woodBox) => ({
        bottleQuantity: woodBox.bottleQuantity,
        boxQuantity: woodBox.boxQuantity,
        bottleVolume: woodBox.bottleVolume,
      })) || [],
    billingEntityId: expedition.expeditionBillingDetail?.billingEntityId || defaultBillingEntity,
    pickUpLocationId: expedition.pickupInfo?.pickupLocation?.id || prefPickUpLocation,
    comment: expedition?.deliveryInfo?.comment || undefined,
    insurance: expedition?.expeditionOptions?.insurance || false,
    dapOption: expedition?.expeditionOptions?.dapOption || false,
    express: expedition?.expeditionOptions?.express || false,
    reference: expedition?.expeditionBillingDetail?.reference || undefined,
    newFilesId: [],
    removedFilesId: [],
  };
};
